import BusinessBranchDisplay from './BusinessBranchDisplay'

export default BusinessBranchDisplay;